<template>
    <div class="templete">
        <div class="tabs">
            <div style="position: relative;top:-15px; left: -15px;" :class="['item',item.id == target?'checked': '']"
                class="item" v-for="(item,index) in dataTemplate" :key="index" @click="choose(item)">{{item.name}}</div>
        </div>
        <div class="printSetBox clearfix">
            <div class="left">
                <div class="path" style="margin-top:10px;">
                    <span class="title">捆包号长度字号配置</span>
                </div>
                <div class="baleSetup">
                    <div class="baleItem">
                        <div class="name">字符长度：</div>
                        <div class="slider">
                            <el-slider @change="sliderChange" show-stops :marks="marksOne" :min="8" :max="16"
                                v-model="setData.configs.inputs[3].value"></el-slider>
                        </div>
                    </div>
                    <div class="baleItem">
                        <div class="name">字号大小：</div>
                        <div class="slider">
                            <el-slider @change="sliderChange" :marks="marksTwo" :min="36" :max="90"
                                v-model="setData.configs.inputs[2].value"></el-slider>
                        </div>
                    </div>
                </div>
                <div class="path" style="justify-content: flex-start;">
                    <span class="title">标签字段自定义配置（非洲材）</span>
                    <div class="contractLabel" style="position:relative;">
                        <span class="redQuestion"></span>
                        <div class="labelTip">
                            <div class="labelZhu">注:</div>
                            <div class="laCbelTipC">
                                显示码单：打印规格是混包时，打印规格用混包代替，具体规格看码单
                            </div>
                            <div class="laCbelTipC">
                                不显示码单：打印规格是混包时，因文字过长，将会掉到下一层展示
                            </div>
                        </div>
                    </div>
                </div>
                <div class="group">
                    <template v-for="(item) in setData.configs.fields">
                        <div :class="['item', item.show ? 'checked': '' ]"
                            v-if="(target == 1 && (item.field == 'width' || item.field == 'layer_number')) || item.field == 'qr_code'"
                            :key="item.key" @click="check(item,1)">
                            {{ item.name }}
                        </div>
                    </template>
                </div>
                <div class="path" style="margin-top:20px;">
                    <span class="title"></span>
                </div>
                <div class="group">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.select_brand"
                        :key="item.key" @click="check(item,5)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;">
                    <span class="title"></span>
                </div>
                <div class="group">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.select_grade"
                        :key="item.key" @click="check(item,6)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;">
                    <span class="title"></span>
                </div>
                <div class="group">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.radios"
                        :key="item.key" @click="check(item,7)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;">
                    <span class="title"></span>
                </div>
                <!-- <div class="group">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.brand" :key="item.key" @click="check(item,2)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;">
                    <span class="title"></span>
                </div> -->
                <!-- <div class="group">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.numbers" :key="item.key" @click="check(item,4)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;">
                    <span class="title"></span>
                </div> -->
                <div class="group">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.company"
                        :key="item.key" @click="check(item,3)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="printNumberBox clearfix">
                    <div class="printNumberTitle">打印次数：</div>
                    <el-input class="printNUmberInp" @change="setLabel"
                        v-model.number="setData.configs.print_number[0].value" />
                </div>
                <div class="path companyDefinition" style="margin-top:20px;align-items: flex-start;">
                    <span class="title">
                        公司名称自定义
                        <span class="explain">(添加自定义模板)</span>
                        <span class="add_icon" @click="addCompany"></span>
                    </span>
                    <el-input class="companyName" :class="setData.configs.inputs[0].status ==1?'companyNameChecked':''"
                        placeholder="请输入公司名称" v-model="setData.configs.inputs[0].value" @input="changeComName"
                        @blur="setLabel"></el-input>
                </div>

                <!-- <div class="path" style="margin-top:20px;">
                    <span class="title">公司名称自定义</span>
                </div>
                <el-input class="companyName" v-model="setData.configs.inputs[0].value" @blur="setLabel"></el-input> -->
                <!-- <crop></crop> -->
                <div class="companySet" style="margin-top:20px;">
                    <div class="pathItme" :class="item.status==1?'pathItmeChecked':''"
                        v-for="(item,ind) in setData.configs.company_infos" :key="ind" @click="checkCompany(item,ind)">
                        <div class="listItem">
                            <span class="name">公司名称：</span>
                            <el-input class="companyInput" @click.stop.native @blur="setLabel" v-model="item.name"
                                placeholder="公司名称"></el-input>
                        </div>
                        <div class="listItem">
                            <span class="name">公司地址：</span>
                            <el-input class="companyInput" @click.stop.native @blur="setLabel" v-model="item.address"
                                placeholder="公司地址"></el-input>
                        </div>
                        <div class="listItem">
                            <span class="name">联系电话：</span>
                            <el-input class="companyInput" @click.stop.native @blur="setLabel" v-model="item.phone"
                                placeholder="联系电话"></el-input>
                        </div>
                        <div class="listItem">
                            <span class="name">LOGO：</span>
                            <div class=" companyInputLogo" @click.stop>
                                <el-upload class="uploadCompany" ref='upload_path' drag :show-file-list="false"
                                    :action="oss.host" :data="upload_data" :on-success="handleSuccess"
                                    :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                                    <div class="uploadDiv" @click="uploadParams(item,ind)">
                                        <el-image v-if="item.logo!=''" :src="item.logo" fit="cover"
                                            class="uploadImage"></el-image>
                                        <img v-else src="/icon/plus-default@2x.png" class="uploadImageAdd" />
                                    </div>
                                </el-upload>
                                <div v-if="item.logo!=''" class="deleteIcon" @click="deleteLogo(item,ind)"><i
                                        class="el-icon-close"></i>
                                </div>
                            </div>
                        </div>
                        <div class="listItem">
                            <span class="name">微信二维码：</span>
                            <div class="companyInputLogo" @click.stop>
                                <el-upload class="uploadCompany" ref='upload_qrcode_path' drag :show-file-list="false"
                                    :action="oss.host" :data="upload_data" :on-success="handleQrcodeSuccess"
                                    :before-upload="beforeQrcodeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                                    <div class="uploadDiv" @click="uploadUserQrcodeParams(item,ind)">
                                        <el-image v-if="item.qr_code!=''" :src="item.qr_code" fit="cover"
                                            class="uploadImage">
                                        </el-image>
                                        <img v-else src="/icon/plus-default@2x.png" class="uploadImageAdd" />
                                    </div>
                                </el-upload>
                                <div v-if="item.qr_code!=''" class="deleteIcon" @click="deleteQrcode(item,ind)"><i
                                        class="el-icon-close"></i></div>
                                <span class="del_icon" @click.stop="deleteCompany(ind)"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="path">
                    <span class="title">配置预览</span>
                </div>
                <div class="rightBox">
                    <div :class="['labelBox',printData.config.indexOf(',border,')!=-1?'boxBorder':'']">
                        <div :class="['label_Company',printData.config.indexOf(',border,')!=-1?'boxBorder_bottom':'']">
                            <span v-if="target == 1" class="label_baleNoFzT"
                                :style="{fontSize:setData.configs.inputs[2].value+'px'}">{{printData.bale_no}}</span>
                            <div class="label_CompanyT" v-if="target == 0">
                                <div class="companyName" v-if="printData.config.indexOf(',company_name,')!=-1">
                                    {{printData.company_name}}</div>
                                <div class="companyAddress"><span
                                        v-if="printData.config.indexOf(',company_address,')!=-1">地址:{{printData.company_address}}</span>
                                    <span
                                        v-if="printData.config.indexOf(',company_mobile,')!=-1">电话:{{printData.company_mobile}}</span>
                                </div>
                            </div>
                            <img v-if="printData.company_logo!=''&&printData.config.indexOf(',company_logo,')!=-1"
                                :src="printData.company_logo" class="label_logo" />
                        </div>
                        <div class="labelContent">
                            <div class="kunbao" v-if="target == 0">
                                <div class="kunbaoC" :style="{fontSize:setData.configs.inputs[2].value+'px'}">
                                    {{printData.bale_no}}</div>
                            </div>
                            <div :class="['labelMessBox clearfix',target == 1?'fzOtherTemplate':'']">
                                <div class="labelMess clearfix" v-if="printData.config.indexOf(',breed,')!=-1">
                                    <div class="labelMessKey">品名:</div>
                                    <div class="labelMessValue fzValue">{{printData.breed}}</div>
                                </div>
                                <div class="labelMess clearfix" v-if="printData.config.indexOf(',brand_brand,')!=-1">
                                    <div class="labelMessKey">品牌:</div>
                                    <div class="labelMessValue fzValue">{{printData.brand_brand}}</div>
                                </div>
                                <div class="labelMess clearfix" v-if="printData.config.indexOf(',brand_batch_no,')!=-1">
                                    <div class="labelMessKey">批次:</div>
                                    <div class="labelMessValue fzValue">{{printData.brand_batch_no}}</div>
                                </div>
                                <div class="labelMess clearfix"
                                    v-if="printData.config.indexOf(',brand_attribute,')!=-1">
                                    <div class="labelMessKey">属性:</div>
                                    <div class="labelMessValue fzValue">{{printData.brand_attribute}}</div>
                                </div>
                                <div class="labelMess clearfix" v-if="printData.config.indexOf(',brand_pieces,')!=-1">
                                    <div class="labelMessKey">片数:</div>
                                    <div class="labelMessValue fzValue">{{printData.brand_pieces}}</div>
                                </div>
                                <div class="labelMess clearfix"
                                    v-if="printData.config.indexOf(',thk,')!=-1 && target == 0">
                                    <div class="labelMessKey">规格:</div>
                                    <div class="labelMessValue fzValue">{{printData.thk}}</div>
                                </div>
                                <div class="labelMess clearfix"
                                    v-if="printData.config.indexOf(',length_thickness,')!=-1 && printData.config.indexOf(',width,')!=-1 && target == 1">
                                    <div class="labelMessKey">长度x厚度:</div>
                                    <div class="labelMessValue fzValue">{{printData.length_thickness}}</div>
                                </div>
                                <div class="labelMess clearfix" v-if="printData.config.indexOf(',grade_grade,')!=-1">
                                    <div class="labelMessKey">等级:</div>
                                    <div class="labelMessValue fzValue">{{printData.grade_grade}}</div>
                                </div>
                                <div class="labelMess clearfix"
                                    v-if="printData.config.indexOf(',grade_contract_no,')!=-1">
                                    <div class="labelMessKey">合同:</div>
                                    <div class="labelMessValue fzValue">{{printData.grade_contract_no}}</div>
                                </div>
                                <div class="labelMess clearfix" v-if="target == 0">
                                    <div class="labelMessKey">材积:</div>
                                    <div class="labelMessValue">{{printData.original_cube}}</div>
                                </div>
                                <div class="labelMess clearfix"
                                    v-if="printData.config.indexOf(',layer_number,')!=-1 && (target == 0 || (target ==1 && printData.config.indexOf(',width,')==-1)) ">
                                    <div class="labelMessKey">层数:</div>
                                    <div
                                        :class="['labelMessValue',printData.config.indexOf(',width,')==-1?'fzValue':'']">
                                        {{printData.layer_number}}</div>
                                </div>
                                <div class="labelMess clearfix thiWidth"
                                    v-if="printData.config.indexOf(',length_thickness,')!=-1 && printData.config.indexOf(',width,')==-1 && target == 1">
                                    <div class="labelMessKey">长度x厚度:</div>
                                    <div class="labelMessValue fzValue">{{printData.length_thickness}}</div>
                                </div>
                                <div class="labelMess clearfix widthShowView"
                                    v-if="printData.config.indexOf(',width,')!=-1 && target == 1">
                                    <div class="messView messHalf">
                                        <div class="labelMessKey">总宽度:</div>
                                        <div class="labelMessValue">{{printData.total_width}}</div>
                                    </div>
                                    <div class="messView messLeft">
                                        <div class="labelMessKey">材积:</div>
                                        <div class="labelMessValue">{{printData.original_cube}}</div>
                                    </div>
                                    <div class="messView messRight"
                                        v-if="printData.config.indexOf(',layer_number,') !=-1">
                                        <div class="labelMessKey">层数:</div>
                                        <div class="labelMessValue">{{printData.layer_number}}</div>
                                    </div>
                                </div>
                            </div>
                            <img :src="printData.qr_code" class="labelQrCode"
                                v-if="printData.config.indexOf(',qr_code,')!=-1" />
                        </div>
                        <div :class="['labelMess labelMessLast clearfix',target == 1?'fzLabelMess':'']"
                            v-if="printData.config.indexOf(',width,')!=-1">
                            <div class="labelMessKey">码单:</div>
                            <div class="labelMessValue">{{printData.width}}</div>
                        </div>

                        <div :class="['labelCompanyBox',printData.config.indexOf(',border,')!=-1 && target == 1?'boxBorder_top':'']"
                            v-if="target == 1">
                            <div class="leftView" v-if="printData.config.indexOf(',company_qr_code,')!=-1">
                                <img :src="printData.company_qr_code" class="userQrcode" alt="">
                            </div>
                            <div class="rightView">
                                <div class="labelCompany" v-if="printData.config.indexOf(',company_name,')!=-1">
                                    {{printData.company_name}}</div>
                                <div class="labelCompanyMess"><span
                                        v-if="printData.config.indexOf(',company_address,')!=-1">地址：{{printData.company_address}}</span>
                                    <span
                                        v-if="printData.config.indexOf(',company_mobile,')!=-1">电话：{{printData.company_mobile}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .printSetBox .companyName {
        width: 350px;
        margin-top: 10px;
    }

    .printSetBox .companyNameChecked:after {
        display: block;
        content: "";
        width: 21px;
        height: 21px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
        background: url(/icon/checkeded.png) no-repeat;
        background-size: cover;
    }

    .printSetBox .companyName /deep/ .el-input__inner {
        height: 35px;
    }

    .printSetBox .companyName /deep/ .el-input__inner:focus {
        border-color: #b21111;
    }

    .companySet {
        display: block;

        .pathItme {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            position: relative;
            background: #f2f2f2;
            margin-bottom: 10px;
            padding: 10px 0 0 10px;
            border-radius: 4px;
            cursor: pointer;

            .listItem {
                display: flex;
                align-items: center;
                margin-right: 10px;
                margin-bottom: 10px;
                width: 220px;

                .name {
                    flex-basis: 100px;
                    white-space: nowrap;
                    overflow: hidden;
                    font-size: 14px;
                    text-align: right;
                }

                .companyInput {
                    flex: 1;
                    min-width: 120px;
                    text-align: left;
                }

                .companyInputLogo {
                    position: relative;
                    width: 45px;
                    height: 30px;
                    display: inline-block;
                }

                .companyInputLogo:hover .deleteIcon {
                    display: flex;
                }

                .companyInput /deep/ .el-input__inner:focus {
                    border-color: #b21111;
                }

                .companyInput /deep/ .el-input__inner {
                    height: 32px;
                    width: 120px;
                }

                .uploadCompany /deep/ .el-upload-dragger {
                    width: 45px;
                    height: 30px;
                    border-radius: 4px;
                    overflow: hidden;
                    border: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .uploadCompany .uploadDiv {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                }

                .uploadCompany .uploadImage {
                    width: 100%;
                    height: 100%;
                }

                .uploadCompany .uploadImageAdd {
                    width: 12px;
                    height: 12px;
                }

                .deleteIcon {
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 10;
                    width: 45px;
                    height: 30px;
                    background: #B21111;
                    opacity: 0.7;
                    border-radius: 4px;
                    display: none;
                    justify-content: center;
                    align-items: center;
                    font-size: 12px;
                    color: #fff;
                }

                .deleteIcon>i {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 15px;
                    height: 15px;
                    border-radius: 50%;
                    background: #fff;
                    color: #B21111;
                    font-size: 12px;
                }
            }

            .del_icon {
                position: absolute;
                right: -36px;
                top: 5px;
                display: inline-block;
                width: 20px;
                height: 20px;
                background: url(/icon/frame_minus.png) center center no-repeat;
                background-size: 16px 16px;
                cursor: pointer;
            }
        }

        .pathItmeChecked:after {
            display: block;
            content: "";
            width: 21px;
            height: 21px;
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: 1;
            background: url(/icon/checkeded.png) no-repeat;
            background-size: cover;
        }
    }

    .baleSetup {
        margin-bottom: 30px;

        .baleItem {
            padding: 2px 0;
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            .name {
                flex-basis: 130px;
            }

            .slider {
                width: 220px;
                padding: 0 15px;
            }

            .slider /deep/ .el-slider__bar {
                background-color: #B21111;
            }

            .slider /deep/ .el-slider__button {
                border-color: #B21111;
            }
        }
    }

    .path {
        margin-bottom: 7px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            border-left: 4px solid #b21111;
            padding-left: 12px;
            position: relative;
        }

        .add_icon {
            position: absolute;
            right: -36px;
            top: 1px;
            display: inline-block;
            width: 20px;
            height: 20px;
            background: url(/icon/frame_plus.png) center center no-repeat;
            background-size: 16px 16px;
            cursor: pointer;
        }
    }

    .companyDefinition {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .explain {
            font-size: 12px;
            color: #B21111;
        }
    }

    .companyName ::v-deep .el-input__inner {
        line-height: 25px;
        height: 25px;
        font-size: 12px;
    }

    .companyName ::v-deep .el-input__inner:focus {
        border-color: #b21111;
    }

    .tableBox {
        display: block;
    }

    .boxBorder {
        border: 1px solid #ccc;
    }

    .boxBorder_bottom {
        border-bottom: 1px solid #ccc;
    }

    .boxBorder_top {
        border-top: 1px solid #ccc;
    }

    .labelBox {
        width: 14.25cm;
        height: 9.5cm;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
    }

    .label_baleNo {
        font-size: 98px;
        font-weight: 600;
        text-align: center;
        border-bottom: 1px solid #ccc;
        position: relative;
        line-height: 130px;
    }

    .label_baleNoFzT {
        position: absolute;
        z-index: 1;
        left: 86px;
        line-height: 100px;
        text-align: center;
        display: inline-block;
        width: 451px;
        font-weight: 600;
    }

    .label_baleNoT {
        position: relative;
        z-index: 1;
    }

    .label_Company {
        position: relative;
        height: 100px;
    }

    .label_CompanyT {
        position: absolute;
        bottom: 0;
        right: 10px;
    }

    .label_CompanyT .companyName {
        font-size: 24px;
        font-weight: 600;
        text-align: center;
        padding-bottom: 5px;
    }

    .label_CompanyT .companyAddress {
        font-size: 12px;
        text-align: right;
        padding-bottom: 10px;
    }

    .labelContent {
        position: relative;
        padding-right: 160px;
    }

    .labelMessBox {
        padding: 10px 0 10px 10px;
        position: relative;
        height: 115px;
        box-sizing: border-box;
        padding-bottom: 0;
    }

    .kunbao {
        width: 100%;
        padding: 5px 10px;
        box-sizing: border-box;
        text-align: left;
    }

    .kunbaoC {
        font-size: 14px;
        display: inline-block;
        background-color: #dcd9d9;
        font-size: 35px;
        padding: 2px 10px;
        min-width: 200px;
        text-align: center;
    }

    .labelMess {
        float: left;
        text-align: left;
        margin-bottom: 5px;
        width: 50%;
        height: 30px;
        display: flex;
        padding-right: 10px;
    }

    .labelMess:nth-child(2n) {
        float: right;
    }

    .labelMessLast {
        width: 100%;
        padding-left: 10px;
    }

    .labelMessLast .labelMessValue {
        font-size: 12px;
    }

    .labelMessKey {
        display: block;
        font-size: 12px;
        float: left;
        line-height: 45px;
        margin-right: 5px;
    }

    .labelMessValue {
        display: block;
        font-size: 18px;
        font-weight: 600;
        line-height: 30px;
        word-break: break-all;
        border-bottom: 1px solid #000;
        float: left;
        flex: 1;
    }

    .labelMessLong {
        width: 100%;
        text-align: left;
        float: left;
    }

    .labelMessValueLong {
        display: inline;
        font-size: 25px;
        font-weight: 600;
    }

    /* 非洲材其他模版 */
    .fzOtherTemplate {
        height: 174px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .labelMess {
            width: 50%;
            float: none;
            display: flex;
            flex-direction: column;
            height: auto;
            margin-bottom: 12px;

            .labelMessKey {
                line-height: normal;
            }

            .labelMessValue {
                border-bottom: 0;
                margin-left: 6px;
                line-height: 30px;
                word-break: break-all;
            }

            .fzValue {
                font-size: 31px;
            }
        }
    }

    .fzLabelMess {
        float: none;
        margin-bottom: 0;
        height: 30px;

        .labelMessKey {
            line-height: 30px;
        }

        .labelMessValue {
            border-bottom: 0;
        }
    }

    .labelQrCode {
        width: 154px;
        height: 154px;
        position: absolute;
        top: 20px;
        right: 10px;
    }

    .labelCompanyBox {
        text-align: center;
        padding-top: 3px;
        height: 48px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;

        .leftView {
            flex-basis: 56px;

            .userQrcode {
                width: 42px;
                height: 42px;
            }
        }

        .rightView {
            flex: 1;
        }
    }

    .labelCompany {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .labelCompanyMess {
        font-size: 12px;
    }

    .labelCompanyMess span {
        margin-right: 10px;
    }

    .label_logo {
        width: 75px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 10px;
        margin: auto;
        z-index: 0;
    }

    /* // width:14.25cm;height:9.5cm; */

    .printNumberBox {
        margin-top: 20px;
    }

    .printNumberTitle {
        font-size: 14px;
        float: left;
        height: 30px;
        line-height: 30px;
    }

    .printNUmberInp {
        width: 100px;
        float: left;
    }

    .baleSetup {
        margin-bottom: 30px;

        .baleItem {
            padding: 2px 0;
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            .name {
                flex-basis: 130px;
            }

            .slider {
                width: 220px;
                padding: 0 15px;
            }

            .slider /deep/ .el-slider__bar {
                background-color: #B21111;
            }

            .slider /deep/ .el-slider__button {
                border-color: #B21111;
            }
        }
    }

    .path {
        margin-bottom: 7px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            border-left: 4px solid #b21111;
            padding-left: 12px;
        }
    }

    .table_path {
        flex: 1;
        box-shadow: 0px 0px 10px rgba(94, 94, 94, 0.16);
        border-radius: 3px;
        width: 100%;
    }

    .el-icon-refresh {
        margin-right: 10px;
        cursor: pointer;
        color: #F9A602;
        font-weight: 600;
    }

    .tab {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: rgba(51, 51, 51, 1);

        .item {
            border-bottom: 3px solid transparent;
            padding: 4px;
            cursor: pointer;

            &.active {
                border-color: #B21111
            }
        }

        .item+.item {
            margin-left: 75px
        }
    }

    .group {
        display: flex;
        flex-wrap: wrap;

        .item {
            min-width: 85px;
            height: 36px;
            line-height: 32px;
            text-align: center;
            padding: 0 12px;
            border-radius: 3px;
            border: 1px solid rgba(102, 102, 102, 1);
            cursor: pointer;
            margin: 6px;
        }

        .item.checked {
            border: 1px solid rgba(178, 17, 17, 1);
            position: relative;
            color: #B21111;

            &::after {
                display: block;
                content: "";
                width: 21px;
                height: 21px;
                position: absolute;
                right: 0;
                bottom: 0;
                background: url("/icon/checkeded.png") no-repeat;
                background-size: cover;
            }
        }

        .check_all_item {
            height: 36px;
            line-height: 36px;
            text-align: center;
            margin: 6px;
        }
    }

    .flex_1 {
        flex: 1;
    }

    .printSetBox {
        padding-right: 15.25cm;
        box-sizing: border-box;
        position: relative;
    }

    .blue {
        color: rgb(21, 91, 212);
        cursor: pointer;
    }

    .left {
        min-height: 420px;
    }

    .rightBox {
        padding: 20px;
        box-sizing: border-box;
        background-color: F6F7FB;
    }

    .right {
        margin-left: 1cm;
        position: absolute;
        top: 0;
        right: 0;
    }

    .fzOtherTemplate .thiWidth {
        width: 100%;
    }

    .fzOtherTemplate .widthShowView {
        display: flex;
        flex-direction: row;
        width: 100%;
        padding-right: 0;
    }

    .fzOtherTemplate .widthShowView .messView {
        display: flex;
        flex-direction: column;
        padding-right: 10px;
    }

    .messHalf {
        width: 50%;
    }

    .messLeft {
        width: 30%;
    }

    .messRight {
        width: 20%;
    }

    /* // F6F7FB */

    .tabs {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .item {
            min-width: 85px;
            font-size: 14px;
            padding: 5px 15px;
            text-align: center;
            border-radius: 3px;
            border: 1px solid rgba(102, 102, 102, 1);
            cursor: pointer;
            margin: 6px 6px 6px 0;
        }

        .item.checked {
            border: 1px solid rgba(178, 17, 17, 1);
            position: relative;
            color: #B21111;

            &::after {
                display: block;
                content: "";
                width: 21px;
                height: 21px;
                position: absolute;
                right: 0;
                bottom: 0;
                background: url("/icon/checkeded.png") no-repeat;
                background-size: cover;
            }
        }

        .item+.item {
            margin-left: 25px;
        }
    }

    .redQuestion {
        display: block;
        width: 15px;
        height: 15px;
        background: url("/icon/question.png") no-repeat 100%;
        background-size: 100% 100%;
    }

    .labelTip {
        display: none;
        position: absolute;
        top: 20px;
        left: -150px;
        z-index: 1;
        width: 250px;
        text-align: left;
        background-color: #fff;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 1px 1px 5px #ccc;
        padding-left: 30px;
    }

    .laCbelTipC {
        color: #606266;
        font-size: 12px;
    }

    .labelZhu {
        font-size: 12px;
        color: #b21111;
        position: absolute;
        top: 10px;
        left: 10px;
    }

    .contractLabel:hover {
        cursor: pointer;
    }

    .contractLabel:hover .labelTip {
        display: block;
    }
</style>
<script>
    // import crop from "../crop"
    export default {
        data() {
            return {
                dataTemplate: [
                    { name: '默认模版', id: 0, isChecked: false },
                    { name: '其他模版', id: 1, isChecked: false },
                ],
                target: 0,
                setData: {
                    category: 2,
                    configs: {
                        fields: [],
                        brand: [],
                        company: [],
                        company_infos: [],
                        numbers: [],
                        radios: [],
                        inputs: [
                            { key: "title", name: "", show: true, sort: 0, value: localStorage.dw_erp_company_name },
                            { key: "background", name: "", show: true, sort: 1, value: '' },
                            { key: "bale_size", name: "捆包字号", show: true, sort: 2, value: 8 },
                            { key: "bale_length", name: "捆包位数", show: true, sort: 3, value: 90 },
                        ],
                        select_breed: [],
                        select_grade: [],
                        print_number: [
                            {
                                key: "print_number",
                                name: "打印次数",
                                value: 0,
                                show: true
                            }
                        ]
                    },
                    tpl: ''
                },
                detailConfig: [],
                printData: {
                    bale_no: "KB8888",
                    grade: "1COM",
                    attribute: "RO",
                    code: "code",
                    breed: "桃花芯",
                    brand_brand: 'TWP',
                    brand_batch_no: '43589',
                    brand_attribute: '毛边',
                    brand_pieces: '166',
                    brand: "TWP",
                    grade_grade: 'AA',
                    original_thickness: "4/4",
                    original_length: "9-10",
                    grade_contract_no: 'HT200340',
                    layer_number: '27',
                    total_width: '3999',
                    original_cube: '3.3592',
                    width: '2.8*30*(301+302+302+304+315+313+309+308+309+308+307+313+308))',
                    supplier: "谱木科技",
                    company_name: localStorage.dw_erp_company_name,
                    company_address: "江苏省太仓市龙江路387号(2号仓库)",
                    company_mobile: "13888888888",
                    company_logo: "/icon/logo2.png",
                    qr_code: "/icon/code.png",
                    company_qr_code: "/icon/code.png",
                    thk: "2.3*102",
                    length_thickness: '2.8*30',
                    contract_no: "2020202020",
                    batch_no: "TF727324",
                    container_no: "HG832424",
                    original_bale: "GD888888",
                    pieces: "11",
                    config: ""
                },
                printNumber: 0,

                marksOne: {
                    8: "8个字符",
                    16: "16",
                },
                marksTwo: {
                    36: "36像素",
                    90: "90",
                },
                upload_data: {},
                oss: {
                    host: "",
                },
                companyParams: {},
                companyNum: '',
            }
        },
        created() {
            this.getList();
            this.getTag();
        },
        components: {
            // crop
        },
        watch: {
            setData: {
                deep: true,
                handler(a, b) {
                    if (a.configs.inputs[3]) {
                        let text = "kb88888888888888";
                        this.printData.bale_no = text.substring(0, a.configs.inputs[3].value);
                    }
                }
            }
        },
        methods: {
            getTag(name) {
                this.postFunc('/erp/print.tag.default.tpl', {}, res => {
                    this.target = res.data.data.template_id && res.data.data.template_id[3] ? res.data.data.template_id[3] : 0;
                    this.getList();
                })
            },
            getList(name) {
                this.postFunc("/erp/print.set.tag.get", { category: 2, tpl: this.target }, res => {
                    this.setData.configs.fields = res.data.data.fields;
                    this.setData.configs.brand = res.data.data.brand;
                    this.setData.configs.company = res.data.data.company;
                    this.setData.configs.numbers = res.data.data.numbers;
                    this.setData.configs.select_breed = res.data.data.select_breed;
                    this.setData.configs.select_brand = res.data.data.select_brand;
                    this.setData.configs.select_grade = res.data.data.select_grade;
                    this.setData.configs.print_number = res.data.data.print_number;
                    this.setData.configs.radios = res.data.data.radios;
                    this.printNumber = res.data.data.print_number[0].value;
                    if (res.data.data.inputs) {
                        this.setData.configs.inputs = res.data.data.inputs;
                        this.printData.company_name = res.data.data.inputs[0].value;
                    }
                    this.setData.configs.company_infos = res.data.data.company_infos;
                    // 渲染公司自定义
                    if (res.data.data.company_infos && res.data.data.company_infos.length > 0) {
                        this.printData.company_name = res.data.data.inputs[0].value;
                        this.printData.company_address = "江苏省太仓市龙江路387号(2号仓库)";
                        this.printData.company_mobile = '13888888888';
                        this.printData.company_logo = "/icon/logo2.png";
                        this.printData.company_qr_code = "/icon/code.png";
                        res.data.data.company_infos.forEach(em => {
                            if (em.status == 1) {
                                this.printData.company_name = em.name;
                                this.printData.company_address = em.address;
                                this.printData.company_mobile = em.phone;
                                this.printData.company_logo = em.logo;
                                this.printData.company_qr_code = em.qr_code;
                            }
                        })
                    }
                    this.printData.config = "," + (res.data.data.configs.join(",")).toString() + ",";
                    this.setData.tpl = this.target;
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            choose(row) {
                this.target = row.id;
                this.setData.tpl = row.id;
                this.getList('upData');
            },
            check(item, type) {
                let arr = ['fields', 'brand', 'company', 'numbers', 'select_brand', 'select_grade', "radios"];
                let selectType = false;
                let selectFlag = false;
                // 码单的特殊处理
                if (type == 1 && item.field != "width" && item.field != "layer_number" && item.field != "qr_code") {
                    return;
                } else {
                    arr[type - 1] == "brand" || arr[type - 1] == "numbers" || arr[type - 1] == "select_brand" || arr[type - 1] == "select_grade" ? selectType = true : selectType = false;
                    arr[type - 1] == "brand" || arr[type - 1] == "numbers" ? selectFlag = true : selectFlag = false;
                    this.setData.configs[arr[type - 1]].forEach(it => {
                        if (item.key == it.key) {
                            it.show = !it.show;
                        }
                        if (selectType) {
                            if (selectType && selectFlag) {
                                if (item.key != it.key) {
                                    it.show = false;
                                }
                            } else {
                                if (item.key == it.key) {
                                    it.show = true;
                                } else {
                                    it.show = false;
                                }
                            }
                        }
                    })
                }
                this.setData.tpl = this.target;
                this.setLabel()
            },
            changeComName(val) {
                this.printData.company_name = val;
            },
            checkCompany(item, num) {
                this.setData.configs.company_infos.forEach((em, index) => {
                    if ((item.id && item.id == em.id) || index == num) {
                        em.status = em.status == 0 ? 1 : 0;
                    } else {
                        em.status = 0;
                    }
                })
                // 选中公司
                let isCompany = this.setData.configs.company_infos.some(em => (em.status == 1));
                this.setData.configs.inputs[0].status = isCompany ? 0 : 1;
                this.setLabel();
            },
            sliderChange() {
                this.setLabel();
            },
            setLabel() {
                let params = JSON.parse(JSON.stringify(this.setData));
                params.tpl = this.target;
                // 北美材 默认 欧洲材 字体大小
                if (params.tpl == 0) {
                    localStorage.setItem('defaultFzSize', this.setData.configs.inputs[2].value);
                } else if (params.tpl == 1) {
                    localStorage.setItem('europeFzSize', this.setData.configs.inputs[2].value);
                }
                this.postFunc("/erp/print.set.tag.update", this.setData, res => {
                    this.tip("设置成功", "success")
                    // this.printData.config = ","+(res.data.data.configs.join(",")).toString()+","
                    this.getList()
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },

            addCompany() {
                this.setData.configs.company_infos.push({
                    name: '', address: '', phone: '', logo: '', qr_code: '', status: 0
                })
            },
            deleteCompany(num) {
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if (index == num) {
                            this.setData.configs.company_infos.splice(index, 1);
                        }
                    })
                }
            },
            // 上传logo
            uploadParams(item, num) {
                this.companyParams = item;
                this.companyNum = num;
            },
            handleSuccess(res) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if ((companyParams.id && item.id == companyParams.id) || this.companyNum == index) {
                            item.logo = res.data.base_url
                        }
                    })
                }
                this.setLabel();
            },
            deleteLogo(em, num) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if (em.id == item.id) {
                            item.logo = ''
                        }
                    })
                }
                this.setLabel();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },

            // 上传微信二维码
            uploadUserQrcodeParams(item, num) {
                this.companyParams = item;
                this.companyNum = num;
            },
            handleQrcodeSuccess(res) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if ((companyParams.id && item.id == companyParams.id) || this.companyNum == index) {
                            item.qr_code = res.data.base_url
                        }
                    })
                }
                this.setLabel();
            },
            deleteQrcode(item, num) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((em, index) => {
                        if (item.id == em.id) {
                            item.qr_code = ''
                        }
                    })
                }
                this.setLabel();
            },
            beforeQrcodeUpload(file) {
                this.file = file;
                return this.getOss();
            },

            // 上传 oss
            getOss() {
                let self = this;
                return new Promise((resolve, reject) => {
                    window.axios.post(window.oss_url + "/tool/v1/oss.policy.get", {
                        operate_code: "shop-excel"
                    }).then((response) => {
                        if (response.data.code == 0) {
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key: self.oss.dir + "${filename}",
                                policy: self.oss.policy,
                                OSSAccessKeyId: self.oss.accessid,
                                success_action_status: "200",
                                callback: self.oss.callback,
                                signature: self.oss.signature,
                                'Cache-Control': self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(() => {
                        reject();
                    })
                })
            }
        }
    }
</script>